import { Card, Button } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { useStake } from "@/src/hooks/useStake";
import { useAccount } from "wagmi";
import { toast } from "react-hot-toast";

export const PendingRewards = () => {
  const { pendingRewards, pendingNetRewards } = useBalances();
  const { onClaimPendingRewards, onClaimAsAirdrop } = useStake();
  const { isConnected } = useAccount();

  const handleRewards = async () => {
    if (!isConnected) return;

    toast.promise(onClaimPendingRewards(), {
      loading: "Transaction is in progress",
      success: "Successfully claimed FRB",
      error: (data) => data,
    });
  }
  const handleAirdrop = async () => {
    if (!isConnected) return;

    toast.promise(onClaimAsAirdrop(), {
      loading: "Transaction is in progress",
      success: "Successfully added FRB to airdrop",
      error: (data) => data,
    });
  }
  return (
    <Card>
      <div className="space-y-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
          Pending Rewards
        </h2>

        <div className="text-center py-2">
          <span className="text-2xl sm:text-3xl font-bold text-foreground font-mono">
            {parseFloat(pendingRewards).toFixed(2)}
          </span>
          <span className="text-lg text-primary font-semibold ml-2">FRB</span>
        </div>

        {/* Claim Net Rewards */}
        <div className="bg-secondary/30 rounded-xl p-4 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-foreground">Claim Net Rewards</span>
            <span className="text-lg font-bold text-foreground font-mono">
              {parseFloat(pendingNetRewards).toFixed(2)}
              <span className="text-primary font-semibold ml-1 text-sm">FRB</span>
            </span>
          </div>
          <div className="flex flex-wrap gap-2 text-xs text-muted-foreground">
            <span className="bg-background/50 rounded-md px-2 py-0.5">2.5% LP Fee</span>
            <span className="bg-background/50 rounded-md px-2 py-0.5">75% Burned</span>
          </div>
          <Button onClick={handleRewards} disabled={parseFloat(pendingRewards)===0}>
            Claim Rewards
          </Button>
        </div>

        {/* Claim As Airdrop */}
        <div className="bg-secondary/30 rounded-xl p-4 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-foreground">Claim As Airdrop</span>
            <span className="text-lg font-bold text-foreground font-mono">
              {parseFloat(pendingRewards*625000/1000000).toFixed(2)}
              <span className="text-primary font-semibold ml-1 text-sm">FRB</span>
            </span>
          </div>
          <div className="flex flex-wrap gap-2 text-xs text-muted-foreground">
            <span className="bg-background/50 rounded-md px-2 py-0.5">0% LP Fee</span>
            <span className="bg-background/50 rounded-md px-2 py-0.5">37.5% Burned</span>
          </div>
          <Button onClick={handleAirdrop} disabled={parseFloat(pendingRewards)===0}>
            Claim As Airdrop
          </Button>
        </div>
      </div>
    </Card>
  );
};
